import { useDispensary } from 'src/hooks/use-dispensary';
import { getDispensaryEnabledForPersonalization } from 'shared/helpers/personalization/settings';

export function useRecentlyViewedEnabled(): boolean {
  // Recently Viewed Carousel
  const dispensary = useDispensary();

  const personalizationEnabled = getDispensaryEnabledForPersonalization(dispensary);

  return personalizationEnabled;
}
